/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import React from 'react';

import { Chip, Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

const FeedbackChoiceGroup = ({ group, selectedValue, onSelect, disabled, styles }) => {
  const intl = useIntl();

  return (
    <Stack sx={styles.questionBlock}>
      <Typography component="p" variant="body2" sx={styles.questionLabel}>
        {intl.formatMessage({ id: group.questionStringId })}
      </Typography>
      <Stack direction="row" sx={styles.chipRow}>
        {group.choices.map(choice => {
          const isSelected = selectedValue === choice.value;

          return (
            <Chip
              key={choice.value}
              label={intl.formatMessage({ id: choice.labelStringId })}
              clickable
              disabled={disabled}
              color={isSelected ? 'primary' : 'default'}
              variant={isSelected ? 'filled' : 'outlined'}
              onClick={() => onSelect(group.id, choice.value)}
              sx={{
                ...styles.choiceChip,
                ...(isSelected ? styles.choiceChipSelected : {}),
              }}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};

export default FeedbackChoiceGroup;
